import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <FAQSection />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <CommentsSection />
        <CarouselSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}